import type React from 'react';

import { useSchedule } from '@entities/schedules';

import { getFullName } from '@shared/helpers';

import { getCurrentAge } from './lib';
import * as st from './styles.module.scss';

type Props = {
	id: number;
};

export const BusyVisitor: React.FC<Props> = ({ id }) => {
	const { schedule } = useSchedule(id);

	return (
		<span className={st.visitor}>
			{schedule && `${getFullName(schedule.user)}, ${getCurrentAge(schedule.user.birth_date)}`}
		</span>
	);
};
